export default "__VITE_ASSET__3d7ed32a__"